import HardwareSerializer from 'eflex/serializers/hardware';

export default class EdhrSerializer extends HardwareSerializer {}
